export const environment = {
  production: false,
  apiurl: "https://devtisaapapi.vemoit.com",
  driverFormUrl: "https://devausentismo.vemoit.com/dashboard"
};